import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../context/ToastContext';
import StoreService from '../services/storeService';

const useBillingPortalLauncher = (storeId) => {
  const { t } = useTranslation();
  const { showError } = useToast();
  const [loading, setLoading] = useState(false);

  const openBillingPortal = useCallback(async () => {
    if (!storeId || loading) {
      return;
    }

    try {
      setLoading(true);

      const result = await StoreService.createBillingPortalSession(storeId);
      const portalUrl = result?.url;

      if (!portalUrl) {
        throw new Error(t('stores.billing.errors.invalidUrl'));
      }

      window.location.assign(portalUrl);
    } catch (err) {
      console.error('Error creating billing portal session:', err);

      if (err?.response?.status === 403) {
        showError(t('stores.billing.errors.ownerOnly'));
        return;
      }

      showError(err?.response?.data?.message || err?.message || t('stores.billing.errors.open'));
    } finally {
      setLoading(false);
    }
  }, [loading, showError, storeId, t]);

  return {
    openBillingPortal,
    loading
  };
};

export default useBillingPortalLauncher;